import { render, staticRenderFns } from "./status-dropdown.vue?vue&type=template&id=4f99b275"
import script from "./status-dropdown.vue?vue&type=script&lang=js"
export * from "./status-dropdown.vue?vue&type=script&lang=js"
import style0 from "./status-dropdown.vue?vue&type=style&index=0&id=4f99b275&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports